/* Landing page interactions: countdown, gallery, before/after slider, add-to-cart */
(function () {
  // Countdown timer
  document.querySelectorAll('[data-lp-timer]').forEach(function (el) {
    var minutes = parseInt(el.getAttribute('data-lp-timer'), 10) || 15;
    var endKey = 'lp-timer-' + (el.getAttribute('data-lp-timer-id') || 'default');
    var now = Date.now();
    var stored = parseInt(sessionStorage.getItem(endKey), 10);
    var end = (stored && stored > now) ? stored : now + minutes * 60 * 1000;
    sessionStorage.setItem(endKey, end);

    var mEl = el.querySelector('[data-m]');
    var sEl = el.querySelector('[data-s]');
    var hEl = el.querySelector('[data-h]');

    function tick() {
      var diff = Math.max(0, end - Date.now());
      var totalSec = Math.floor(diff / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
      if (diff <= 0) clearInterval(intv);
    }
    tick();
    var intv = setInterval(tick, 1000);
  });

  // Gallery thumbnail switching
  document.querySelectorAll('[data-lp-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-lp-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-lp-gallery-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var src = t.getAttribute('data-src');
        if (src && main) main.setAttribute('src', src);
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  // Before/after slider
  document.querySelectorAll('[data-lp-ba]').forEach(function (ba) {
    var track = ba.querySelector('[data-lp-ba-track]');
    var prev = ba.querySelector('[data-lp-ba-prev]');
    var next = ba.querySelector('[data-lp-ba-next]');
    if (!track) return;
    function step(dir) {
      var w = track.clientWidth * 0.5;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });
})();

/* Add to cart — then go straight to checkout */
(function () {
  var form = document.getElementById('lp-product-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = form.querySelector('[name="add"]');
    var originalText = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
      form.submit();
    });
  });
})();